<ng-container *ngIf="isLoading$ | async"></ng-container>
<!-- <div class="header-top ln-ar" style="display: none;">
    <div class="container">
        <div class="row">
            <div class="col-sm-4 col-lg-4">
                <div class="header-top-item">
                    <div class="header-top-left">
                        <ul>
                            <li>
                                <app-language></app-language>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div> -->
<div class="navbar-area sticky-top">
    <div class="mobile-nav text-center">
        <a routerLink="/" class="logo"><img src="assets/img/logo-two.png" alt="Logo">
            <app-language style="margin: 30px;"></app-language>
        </a>
    </div>
    <div class="main-nav Main-color">
        <div class="container-fluid">
            <nav class="navbar navbar-expand-md navbar-light">
                <img *ngIf="language == 'en'" class="img img-responsive" src="assets/img/logo.png" alt="Logo"
                    style="margin-left:75px !important;">
                <div class="collapse navbar-collapse mean-menu" id="navbarSupportedContent">

                    <div class="lang-arabic" *ngIf="language == 'ar'"> <app-language></app-language></div>

                    <ul class="navbar-nav" id="nav">
                        <li class="nav-item"><a routerLink="/" class="nav-link" routerLinkActive="active"
                                [routerLinkActiveOptions]="{exact: true}">{{'MENU.HOME' | translate}}</a></li>
                        <!-- <li class="nav-item"><a routerLink="/about" class="nav-link" routerLinkActive="active"
                                [routerLinkActiveOptions]="{exact: true}">{{'MENU.ABOUTUS' | translate}}</a></li> -->

                        <li class="nav-item dropdown">
                            <a class="nav-link dropdown-toggle" href="#" id="servicesDropdown" role="button"
                                data-bs-toggle="dropdown" aria-expanded="false">{{'MENU.ABOUTUS' | translate}}
                            </a>
                            <ul class="dropdown-menu" aria-labelledby="servicesDropdown">
                                <li><a class="nav-item" routerLink="/about"
                                        routerLinkActive="active">{{'MENU.ABOUTUSNew' | translate}}</a></li>
                                <li><a class="nav-item" routerLink="/boards/1" routerLinkActive="active">{{'MENU.Board'
                                        | translate}}</a></li>
                                <li><a class="nav-item" routerLink="/boardofdirectors/2"
                                        routerLinkActive="active">{{'MENU.BoardOfDirectors' | translate}}</a></li>
                            </ul>
                        </li>
                         <li class="nav-item dropdown">
                            <a class="nav-link dropdown-toggle" href="#" id="entitiesDropdown" role="button"
                                data-bs-toggle="dropdown" aria-expanded="false">{{'MENU.ENTITIES' | translate}}
                            </a>
                            <ul class="dropdown-menu" aria-labelledby="entitiesDropdown">
                                <li><a class="nav-item" routerLink="/hospitals/1"
                                        routerLinkActive="active">{{'MENU.HOPITALS' | translate}}</a></li>
                                <li><a class="nav-item" routerLink="/medicalcenters/2"
                                        routerLinkActive="active">{{'MENU.MEDICALCENTERS' | translate}}</a></li>
                            </ul>
                        </li>
                         <li class="nav-item"><a routerLink="/news" class="nav-link" routerLinkActive="active"
                                [routerLinkActiveOptions]="{exact: true}">{{'MENU.BLOG' | translate}}</a></li>

                        <li class="nav-item"><a routerLink="/investment" class="nav-link" routerLinkActive="active"
                                [routerLinkActiveOptions]="{exact: true}">{{'MENU.OFFERS' | translate}}</a></li>
                        <!-- <li class="nav-item"><a routerLink="/specialties" class="nav-link" routerLinkActive="active"
                                [routerLinkActiveOptions]="{exact: true}">{{'MENU.SPECIALTIES' | translate}}</a></li> -->
                       
                       
                        <li class="nav-item"><a href="https://balsamvolt.com/VOLT/Public/frmAvailablePositionsList.aspx" target="_blank" class="nav-link" routerLinkActive="active"
                                [routerLinkActiveOptions]="{exact: true}">{{'MENU.CAREERS' | translate}}</a></li>
                        <li class="nav-item"><a routerLink="/contact" class="nav-link" routerLinkActive="active"
                                [routerLinkActiveOptions]="{exact: true}">{{'MENU.CONTACTUS' | translate}}</a></li>
                    </ul>
                    <div class="lang-arabic" *ngIf="language == 'en'"> <app-language></app-language></div>
                </div>
                <img *ngIf="language == 'ar'" class="img img-responsive" src="assets/img/logo.png" alt="Logo"
                    style="margin-left:75px !important;">
            </nav>
        </div>
    </div>
</div>